import { useQuery } from 'react-query';
import { AutomaticQuestionService } from '../../../services/v1/interview_intelligence/AutomaticQuestionService';

export const useAutomaticQuestions = (interviewId: number, expand?: string[]) =>
  useQuery({
    queryKey: ['automatic_questions', interviewId, { expand: expand }],
    queryFn: () => AutomaticQuestionService.list(interviewId, expand),
  });
